import React, { useState } from 'react';
import { Box, CircularProgress, Typography, Container, Paper, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import ForgotPasswordForm from './ForgotPasswordForm';

type AuthView = 'signIn' | 'signUp' | 'forgotPassword';

const AuthContainer: React.FC = () => {
  const [currentView, setCurrentView] = useState<AuthView>('signIn');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const renderAuthForm = () => {
    switch (currentView) {
      case 'signIn':
        return (
          <LoginForm 
            onSignUp={() => setCurrentView('signUp')}
            onForgotPassword={() => setCurrentView('forgotPassword')}
            setLoading={setLoading}
            setError={setError}
          />
        );
      case 'signUp':
        return (
          <SignUpForm 
            onSignIn={() => setCurrentView('signIn')}
            onSuccess={() => setCurrentView('signIn')}
          />
        );
      case 'forgotPassword':
        return (
          <ForgotPasswordForm 
            onSignIn={() => setCurrentView('signIn')}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Container maxWidth="sm" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 500 }}>
        <Box sx={{ mb: 2, textAlign: 'center' }}>
          <Typography variant="h4" component="h1" gutterBottom>
            AmslerGridDaily
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Track your vision health with daily tests
          </Typography>
        </Box>
        
        {error && (
          <Typography color="error" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}
        
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          renderAuthForm()
        )}
        
        <Box sx={{ mt: 3, textAlign: 'center', display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 2 }}>
          <Link 
            component={RouterLink} 
            to="/public-privacy" 
            variant="body2" 
            color="primary"
          >
            Privacy Policy
          </Link>
          <Link 
            component={RouterLink} 
            to="/terms-of-service" 
            variant="body2" 
            color="primary"
          >
            Terms of Service
          </Link>
          <Link 
            component={RouterLink} 
            to="/docs/user-guide" 
            variant="body2" 
            color="primary"
          >
            User Guide
          </Link>
          <Link 
            component={RouterLink} 
            to="/faq" 
            variant="body2" 
            color="primary"
          >
            FAQ
          </Link>
        </Box>
      </Paper>
    </Container>
  );
};

export default AuthContainer; 